import { toAmount } from "./amount";

export const calculatePMT = (
	loanAmount: number,
	rate: number,
	loanTermMonths: number
): number => {
	if (rate === 0) {
		return Math.round((loanAmount / loanTermMonths) * 100) / 100;
	}

	const factor = Math.pow(1 + rate, loanTermMonths);
	const payment = (loanAmount * rate * factor) / (factor - 1);

	return Math.round(payment * 100) / 100;
};

export interface MonthlyPaymentOffer {
	interestRate?: number | string | null;
	terms?: number | string | null;
	termFee?: number | string | null;
}

export const loanMonthlyPaymentCalc = (
	offer: MonthlyPaymentOffer,
	currentAmount: number
): number | null => {
	const interestRate = toAmount(offer.interestRate);
	const loanTermMonths = toAmount(offer.terms);

	if (interestRate === null || loanTermMonths === null || loanTermMonths <= 0) {
		return null;
	}

	const monthlyInterestRate = interestRate / 100 / 12;

	return (
		calculatePMT(currentAmount, monthlyInterestRate, loanTermMonths) +
		(toAmount(offer.termFee) ?? 0)
	);
};
